<template>
  <section class="bd-content">
    <!-- :style="`height: ${getScrollHeight()}`" -->
    <div class="bd-example vue-example vue-example-b-embed">
      <div class="embed-responsive embed-responsive-16by9">
        <iframe
      width="100%"
      height="100%"
      :src="`https://www.youtube.com/embed/${videoId}`"
      title="YouTube video player"
      frameborder="0"
      allowfullscreen
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
    ></iframe>
    <!-- metal deer video browser version ees hamaaraad yavahgui bsan tul soliv -->
        <!-- <youtube :video-id="videoId" class="wd-100p"></youtube> -->
      </div>
    </div>
  </section>
</template>
<script>
import { getIdFromUrl } from "vue-youtube";

export default {
  name: "detail",
  props: {
    url: {
      type: String,
      default: () => null
    }
  },
  data() {
    return {
      videoId: null
    };
  },

  mounted() {
    try {
      this.videoId = this.getYouTubeId();
      // this.videoId = getIdFromUrl(this.url);
    } catch (err) {
      // eslint-disable-next-line
      //console.log(err);
    }
  },
  methods: {
    getYouTubeId(){
      const match = this.url.match(/(?:youtube\.com\/(?:watch\?v=|embed\/)|youtu\.be\/)([a-zA-Z0-9_-]{11})/);
      return match ? match[1] : null;
    },
    getScrollHeight() {
      let mh = 170;
      if (screen.width <= 1024) {
        mh = 80;
      }
      return `calc(${window.innerHeight}px - ${mh}px);`;
    }
  }
};
</script>
